const config = {
	baseUrl: process.env.REACT_APP_API_URL || "http://localhost:6874/api",
	position_stack_key: process.env.REACT_APP_POSITION_STACK_KEY || "b108873b531f412bee73c342a818d23e",
	token: "/token",
	company: "/company",
	client: "/client",
	admin: "/admin",
	login: "/login",
	signup: "/signup",
	addStation: "/addStation",
	CLIENT: "client",
	COMPANY: "company",
	ADMIN: "admin",
	bookRoute: "/bookRoute",
	trackRoute: "/trackRoute",
	pincodeurl: `https://nominatim.openstreetmap.org/search?format=json&q=`,
	findFastestRoute: "/findFastestRoute",
	pintocityurl: "https://api.postalpincode.in/pincode/",
};
export default config;
